import { FacilityBrand } from '@/gqlConstants';
import { FacilityFieldsFragment } from '@/graphql/__generated/sdk';
import { TAGBrand } from '@/types';
import { getGraphHeaders } from '@/utils/getGraphHeaders';

import { brandThemeToFacilityBrand } from './brandThemeToFacilityBrand';

/** get facility details from enterprise graphql
 * @param brand - brand of the facility
 * @param facilityCode - code of the facility
 * @param appName - name of the application
 * @param appVersion - version of the application
 * @param enterpriseGraphqlUrl - url of the enterprise graphql
 * @returns facility details
 */
export async function getFacilityDetails(
	brand: TAGBrand,
	facilityCode: string,
	appName: string,
	appVersion: string,
	enterpriseGraphqlUrl: string
) {
	const facilityBrand = brandThemeToFacilityBrand(brand);
	const { getGraphQLClient } = await import(/* webpackChunkName:"getGraphQLClient" */ '../graphql/getGraphQLClient');
	const facilityInfoResp = await getGraphQLClient(enterpriseGraphqlUrl).facilityByCode(
		{
			code: facilityCode,
			brand: facilityBrand as FacilityBrand,
		},
		getGraphHeaders(appName, appVersion)
	);
	const facilityInfo = facilityInfoResp.facility as FacilityFieldsFragment;
	return facilityInfo;
}
